import styled from "styled-components";

export const Container = styled.section`
  border-radius: 10px;
  background: white;
  padding: 40px;
`;

export const SumInsuredHeaderWrapper = styled.header`
  border-radius: 14px;
  background: #f7cb594f;
  padding: 21px 34px;
  display: flex;
  flex-direction: column;
  gap: 38px;
  & > :first-child {
    display: flex;
    flex-direction: ${({ isMultiline }) => (isMultiline ? "column" : "row")};
    gap: ${({ isMultiline }) => (isMultiline ? "24px" : "90px")};
    & > :first-child {
      width: ${({ isMultiline }) => (isMultiline ? "100%" : "140px")};
    }
  }
  & > section:not(:first-of-type) {
    display: flex;
    gap: 90px;
    & > *:not(:last-child) {
      border-right: 1px solid #6b5e7766;
      padding-right: 70px;
    }
    & > :first-child {
      width: 230px;
    }
  }
`;

export const Divider = styled.div`
  width: 1px;
  background: #6b5e7766;
  height: 100%;
  min-height: 50px;
`;

export const GradeStripHeader = styled.header`
  background: white;
  padding: 0 16px;
  border-radius: 6px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AttributeWrapper = styled.div`
  border: 1px solid #231a3d26;
  padding: 36px 34px;
  border-radius: 10px;
`;

export const AgeGridWrapper = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
`;

export const GradeAttributeDetailWrapper = styled.div`
  padding: 36px 34px;
  border: 1px solid #231a3d26;
  border-radius: 10px;
  & > header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
  }
`;

export const GradeAttributesWrapper = styled.section`
  display: grid;
  gap: 24px;
`;

export const CoverageNotesList = styled.ul`
  list-style-type: disc;
  padding-left: 20px;
  display: block;
  & > li {
    display: list-item;
    margin-bottom: 6px;
    line-height: 1.4;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
`;

export const GradeAttributeCardWrapper = styled.section`
  & > header {
    background-color: #452d84;
    border-radius: 4px 4px 0px 0px;
    max-width: 200px;
    padding: 8px 10px;
  }
  & > article {
    border: 1px solid #231a3d66;
    padding: 24px 14px;
    border-radius: 0px 4px 4px 4px;
  }
`;

const ExclusionBtn = styled.button`
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 18px;
  font-family: "Inter";
  font-weight: 500;
  /* width: 212px;
  height: 54px; */
  width: 11.04vw;
  height: 5.0vh;
  padding: 2.4rem;
`

export const ExclusionBtnLight = styled(ExclusionBtn)`
  border: 1px solid rgb(35, 26, 61);
  color: rgb(35, 26, 61);
  background-color: transparent;
  
`;

export const ExclusionBtnDark = styled(ExclusionBtn)`
  border: 1px solid rgba(69, 45, 132, 1);
  color: #fff;
  background-color: rgba(69, 45, 132, 1);
`;


export const ExclusionDivContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 36px;
`;

export const ExclusionBtnWrapper = styled.div`
  display: flex;
  gap: 15px;
  justify-content: end;
  margin-top: 49px;
`

export const ModalCloseBtn = styled.div`
  cursor: pointer;
`

const ExclusionInputContainer = styled.div`
  display: flex;
  margin-bottom: 4px;
`;

export const ExclusionTextInput = styled.div`
  width: 100%;
  background-color: transparent;
  padding: 1.6rem 2rem 1.6rem 2rem;
  outline: none;
  font-weight: 500;
  border: none;
  border: 1px solid #231a3d;
  border-radius: 10px;
  font-size: 16px;
  color: #4A4A4A;
  font-style: italic;
  letter-spacing: 2px;
  font-family: "Inter";
`;

export const ExclusionInputStyle = {
  width: '100%',
  backgroundColor: 'transparent',
  padding: '1.6rem 2rem',
  outline: 'none',
  fontWeight: 400,
  border: '1px solid #231a3d',
  borderRadius: '10px',
  fontSize: '14px',
  fontFamily: 'Inter',
  color: '#4A4A4A',
};

export const ExclusionDiv = styled.div`
  width: 90%;
  padding-right: 5rem;
  margin-right: auto;
  margin-top: 3rem;
`

export const CoverageDivWrapper = styled.div`
  width: 100%;
  padding-right: 5rem;
  padding-left: 2rem;
  margin-right: auto;
  margin-left: auto;
  font-size: 18px;
  display: flex;
  flex-direction : column;
  gap: 16px;
`
